export class InvoiceFile {
  requestId: number;
  appFileId: number;
  fileName: string;
  so: string;
  invoiceNo: string;
  fileTypeId: number;
  fileTypeName: string;
  fileShortDescription: string;
  fileLongDescription: string;
  uploadById: number;
  uploadByName: number;
  uploadDate: Date;
  filePath: string;
  invoicePaid: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/invoice-file.ts